import definition from './notifications.service';

/**
 * NotificationsService settings
 * @type {{name: string, definition: NotificationsService}}
 */
const Service = {
    name: 'NotificationsService',
    definition
};

export {
    Service
};



// WEBPACK FOOTER //
// ./app/services/notifications/index.js